import logo from './asda-logo.svg'
import prideLogo from './asda-pride.svg'
import babyClubLogo from './baby-club.svg'

export default {
  logo,
  prideLogo,
  babyClubLogo,
}



// WEBPACK FOOTER //
// ./common/components/icon/logo/index.js